import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { IMAGES } from "../data";

const POINTS = [
  "Czyszczenie i przygotowanie działek",
  "Mulczowanie terenu i obiektów",
  "Prace minikoparką Bobcat E19",
  "Wyburzenia młotem",
  "Odśnieżanie nowoczesnym sprzętem",
];

export const About = () => {
  return (
    <section
      id="o-nas"
      data-testid="about-section"
      className="bg-white py-16 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="font-anton uppercase text-[#DC2626] tracking-widest text-sm">
            O nas
          </span>
          <h2 className="font-anton uppercase text-[#09090B] text-4xl md:text-5xl mt-3 leading-tight">
            Solidne prace sprzętem Bobcat
          </h2>
          <p className="mt-6 text-zinc-700 text-base md:text-lg leading-relaxed">
            ONE WAY TRANSPORT świadczy usługi nowoczesnym sprzętem Bobcat. Firma
            wykonuje prace związane z czyszczeniem działek, mulczowaniem, pracami
            minikoparką, przygotowaniem terenu, wyburzeniami oraz odśnieżaniem.
          </p>
          <ul className="mt-8 space-y-3">
            {POINTS.map((p) => (
              <li
                key={p}
                data-testid="about-point"
                className="flex items-start gap-3 text-[#09090B] font-medium"
              >
                <CheckCircle2 className="text-[#DC2626] shrink-0 mt-0.5" size={22} />
                {p}
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="relative"
        >
          <div className="border-2 border-[#09090B] shadow-[10px_10px_0_0_rgba(220,38,38,1)]">
            <img
              src={IMAGES.bobcatFront}
              alt="Bobcat S66 ONE WAY TRANSPORT"
              className="w-full h-full object-cover"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
